import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";

const MOAndMADetailTable = ({ colors, rows, columns, onEdit }) => {
  return (
    <Grid
      container
      padding="5px 1px 1px 1px"
      spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }}
      alignItems="center"
    >
      <Grid item xs={12}>
        <TableContainer>
          <Table size="small">
            {/* ---------- Header ---------- */}
            <TableHead sx={{ backgroundColor: colors.primary[400] }}>
              <TableRow>
                <TableCell style={{ padding: 4, textAlign: "center" }} />
                {columns.map((col, idx) => (
                  <TableCell
                    key={idx}
                    style={{
                      padding: "4px",
                      textAlign: col.align || "center",
                    }}
                  >
                    {col.headerName}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            {/* ---------- Body ---------- */}
            <TableBody>
              {rows.map((row, rowIndex) => (
                <TableRow key={rowIndex}>
                  <TableCell>
                    <EditIcon
                      sx={{
                        fontSize: 20,
                        color: "#009688",
                        cursor: "pointer",
                        mr: 1.25,
                      }}
                      onClick={() => onEdit?.(row)}
                    />
                  </TableCell>

                  {columns.map((col, colIndex) => (
                    <TableCell
                      key={colIndex}
                      style={{ padding: 2, border: "1px solid black" }}
                    >
                      <TextField
                        fullWidth
                        disabled
                        size="small"
                        sx={{
                          "& .MuiOutlinedInput-notchedOutline": {
                            border: "none",
                          },
                          "& .MuiInputBase-input": {
                            padding: "2px",
                            textAlign: col.align || "center",
                          },
                        }}
                        variant="outlined"
                        type={col.type || "text"}
                        value={row[col.field] ?? ""}
                      />
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  );
};

export default MOAndMADetailTable;
